import React, { Component } from 'react';

class TinySpinner extends React.Component {
    render() { 
        return <div style={this.props.noMargin ? {marginRight: "0px"} : {}} className="hw-widget__tiny-spinner"></div>;
    }
}
 
export default TinySpinner;